(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      this.header.classList.add('shopify-section-header-sticky');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      this.onScroll();
    }
    setHeaderHeight() {
      if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScrollHandler); }
    onScroll() {
      if (!this.header) return;
      const isScrolled = window.scrollY > 24;
      this.header.classList.toggle('omd-header-scrolled', isScrolled);
      const wrapper = this.header.querySelector('[data-omd-site-header]');
      if (wrapper) wrapper.classList.toggle('omd-header-scrolled', isScrolled);
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  const initOmdHeader = () => {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader || sectionHeader.dataset.omdReady === 'true') return;
    sectionHeader.dataset.omdReady = 'true';
    const openDelay = 65;
    const closeDelay = 120;
    let openTimer;
    let closeTimer;

    const wrapper = sectionHeader.querySelector('[data-omd-site-header]');
    const syncScrollState = () => {
      const isScrolled = window.scrollY > 24;
      sectionHeader.classList.toggle('omd-header-scrolled', isScrolled);
      if (wrapper) wrapper.classList.toggle('omd-header-scrolled', isScrolled);
    };
    syncScrollState();
    window.addEventListener('scroll', syncScrollState, { passive: true });

    const closeAll = (except = null) => {
      sectionHeader.querySelectorAll('[data-omd-mega][open]').forEach((details) => {
        if (details !== except) details.removeAttribute('open');
      });
      const hasOpen = Boolean(sectionHeader.querySelector('[data-omd-mega][open]'));
      sectionHeader.classList.toggle('omd-mega-active', hasOpen);
      const wrapper = sectionHeader.querySelector('[data-omd-site-header]');
      if (wrapper) wrapper.classList.toggle('omd-mega-active', hasOpen);
      document.body.classList.toggle('omd-mega-menu-open', hasOpen);
    };

    sectionHeader.querySelectorAll('[data-omd-mega]').forEach((details) => {
      details.addEventListener('pointerenter', () => {
        if (window.matchMedia('(max-width: 989px)').matches) return;
        clearTimeout(closeTimer);
        openTimer = window.setTimeout(() => {
          closeAll(details);
          details.setAttribute('open', '');
          sectionHeader.classList.add('omd-mega-active');
          const wrapper = sectionHeader.querySelector('[data-omd-site-header]');
          if (wrapper) wrapper.classList.add('omd-mega-active');
          document.body.classList.add('omd-mega-menu-open');
        }, openDelay);
      });
      details.addEventListener('pointerleave', () => {
        if (window.matchMedia('(max-width: 989px)').matches) return;
        clearTimeout(openTimer);
        closeTimer = window.setTimeout(() => closeAll(), closeDelay);
      });
      details.addEventListener('toggle', () => {
        window.requestAnimationFrame(() => {
          const hasOpen = Boolean(sectionHeader.querySelector('[data-omd-mega][open]'));
          sectionHeader.classList.toggle('omd-mega-active', hasOpen);
          const wrapper = sectionHeader.querySelector('[data-omd-site-header]');
          if (wrapper) wrapper.classList.toggle('omd-mega-active', hasOpen);
          document.body.classList.toggle('omd-mega-menu-open', hasOpen);
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!sectionHeader.contains(event.target)) closeAll();
    });

    sectionHeader.querySelectorAll('.menu-drawer-container').forEach((details) => {
      details.addEventListener('toggle', () => {
        document.body.classList.toggle('omd-mobile-menu-open', details.open);
        sectionHeader.classList.toggle('omd-drawer-active', details.open);
        const wrapper = sectionHeader.querySelector('[data-omd-site-header]');
        if (wrapper) wrapper.classList.toggle('omd-drawer-active', details.open);
      });
    });
    sectionHeader.querySelectorAll('[data-omd-drawer-close]').forEach((button) => {
      button.addEventListener('click', () => {
        const details = sectionHeader.querySelector('.menu-drawer-container[open]');
        if (details) details.removeAttribute('open');
      });
    });

    sectionHeader.querySelectorAll('[data-omd-drawer-back]').forEach((button) => {
      button.addEventListener('click', () => {
        const submenu = button.closest('.omd-drawer-accordion[open]');
        if (submenu) submenu.removeAttribute('open');
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOmdHeader);
  else initOmdHeader();
  document.addEventListener('shopify:section:load', initOmdHeader);

  } catch(e) { console.error(e); }
})();
})();
